import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import DdoEditDialogBody from './DdoEditDialogBody';
import DdoEditDialogHeader from './DdoEditDialogHeader';

const DdoEditDialog = ({ show, onHide, id, isEdit, rtl }) => {
  const [modal] = useState({
    isOpen: show,
    title: `${isEdit ? 'Edit' : 'Add'} DDO`,
    hide: onHide,
  });

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      backdrop={'static'}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-edit-dialog"
    >
      <DdoEditDialogHeader modal={modal} />
      <DdoEditDialogBody modal={modal} isEdit={isEdit} id={id} />
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(DdoEditDialog);
